import { useTranslation } from "next-i18next";
import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { printLogs } from "../helpers/helpers";
// import { object } from "prop-types";
import CardContent from "@mui/material/CardContent";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import * as config from "../../next.config";
import { styled } from "@mui/system";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import style from "../../styles/mystyle.module.css";
import DeleteForEverIcon from "@mui/icons-material/DeleteForever";
function Dropzone({ accept, disabled, callBack,open }, props) {
  const { t } = useTranslation();

  const AddCamera = styled(AddAPhotoIcon)(({ theme, locale }) => ({
    fontSize: "5rem",
    color: "#008C8D ",

    "@media (min-width:768px) and (max-width:912px)": {
      fontSize: "6rem",
      color: "#008C8D "
    },
    "@media (min-width:913px)": {
      fontSize: "7rem",
      color: "#008C8D "
    }
  }));
  const [files, setFiles] = React.useState([]);
  const handleDeleteOne = e => {
    let index2 = e.currentTarget.getAttribute("data-id");

    let tempFiles = [...files];
    const newTempFiles = tempFiles.filter(
      (i, index) => parseInt(index) !== parseInt(index2)
    );
 
    setFiles(newTempFiles);
    callBack({files:newTempFiles});
  };
    let tempFiles2 = [...files];
  const onDrop = useCallback(acceptedFiles => {
    // setFiles(acceptedFiles.map(file => {
    //     return Object.assign(file, { preview: URL.createObjectURL(file) })
    // }))
    setFiles(prev => [
      ...prev,
      ...acceptedFiles.map(file =>
      
        Object.assign(file, {
          preview: URL.createObjectURL(file),
          index: files.length
        })
      )
    ]);
     let tempFiles =files;
    // printLogs("acceptedFiles",tempFiles)
    // printLogs("acceptedFilesdd",files.filter(i=>i.File.path!=null))
    // if(files.filter(i=>i.File.path))

 acceptedFiles.map(i=>{
     tempFiles2.push(i);
     
    })
 
    callBack({files:[...tempFiles2]});

        
     
  }, []);
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    acceptedFiles,
  
    
  } = useDropzone({ onDrop, accept, disabled, accept,useFsAccessApi:false });

  const saveImage = async () => {
    // printLogs("t=====>","formData")
    let formData = new FormData();
    // printLogs("")
    formData.append("file", files[0]);
    formData.append("fileEntityClassId", 2143);
    formData.append("note", "this is by web");
    const res = await fetch(`${config.basePath}/api/Files/post`, {
      method: "POST",
      body: formData
    });
    await res.json()
     printLogs("res==========>", );
    printLogs("res==========>22", res);
  };
  return (
    <div
      // style={{
      //   border: "1px black dashed",
      //   borderRadius: "5px",
      //   marginTop: "5%"
      // }}
    >
      <div >
      
        <div className="text-center">
          {/* {isDragActive ? (
            <p className="dropzone-content">{t("messages:dropzoneRealease")}</p>
          ) : (
            <p className="dropzone-content">{t("messages:dropzoneDrag")}</p>
          )} */}
         
         
          {/* {files.length>0?
                    <CardContent>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <Paper
                                    elevation={5}
                                    sx={{
                                        // width: 300,
                                        height: 100,
                                        border: '1px solid',
                                        alignSelf: 'center',
                                        mx: 'auto',
                                        boxShadow: '50px',
                                        borderRadius: '20px',
                                        overflow: 'auto'
                                    }}
                                    style={{
                                        backgroundImage: `url('${files.length > 0 ? files[0].preview:""}')`,
                                        backgroundSize: "contain",
                                        backgroundRepeat: 'no-repeat',
                                    }}
                                >
                                </Paper>
                            </Grid>
                        </Grid>
                    </CardContent>
                    :""} */}

          <div className={style.cardsmedicianorder}>
            <div className={style.card} {...getRootProps({ className: "dropzone" })}>
            <input className="input-zone" {...getInputProps()} />
               <button className={style.stylesbtnmedicianorder}  > 
                <a className={style.AtagIcon}>
           
                  <IconButton component="label"
                            onClick={open}
                         
                        
                            disabled={disabled}
                            // disabled={disabled}
                            //  {...getRootProps()}
                  >
                    {/* <input {...getInputProps()}/>  */}
                    <AddCamera
                     />
                  </IconButton>
                </a>
              </button>
            </div>
            {files.length > 0
              ? files.map((file, index) => (
                  
                  <div className={style.card} key={file.name}>
                    <button className={style.stylesbtnmedicianorder}>
                      <a className={style.AtagIcon}>
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={file.preview}
                          // onLoad={() => {
                          //   URL.revokeObjectURL(file.preview);
                          // }}
                        />
                      </a>
                    </button>
                    <Tooltip title="حذف الصورة">
                      <IconButton
                        edge="end"
                        onClick={handleDeleteOne}
                        disabled={files.length == 0}
                        data-id={index}
                          // {...getRootProps()}
                      >
                         {/* <input {...getInputProps()}/>  */}
                        <DeleteForEverIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ))
              : ""}
          </div>

          {/* <IconButton
                    className={style.stylesbtnmedicianorder} 
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                        fullWidth
                        onClick={open}
                        disabled={disabled}
                    > */}
          {/* <AddCamera /> */}
          {/* add */}
          {/* </IconButton> */}

          {/* <img src={files.length > 0 ? files[0].preview : ""}></img> */}
        </div>
      </div>
      {/* <div className={style.card}>
        <button onClick={async () => await saveImage()}>save</button>
      </div> */}
    </div>
  );
}

export default Dropzone;
